<template>
  <div class="flex flex-col py-4 h-full overflow-hidden">
    <div class="flex items-center">
      <div class="w-1/5 ml-auto">
        <div class="w-full relative">
          <select
            class="block appearance-none w-full bg-gray-100 border border-gray-100 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
          >
            <option selected value="-1">Todos</option>
            <template v-for="category in formCategories">
              <option :key="category.id" :value="category.id">{{category.category_name}}</option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="flex justify-center md:justify-start w-full ml-4 md:w-1/4 text-left">
        <router-link
          to="/cuestionarios/nuevo"
          class="flex items-center px-4 py-2 rounded-full bg-cdmx-green text-white hover:bg-cdmx-green-dark"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" VerBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
            />
          </svg>
          <span class="ml-2">Nueva encuesta</span>
        </router-link>
      </div>
    </div>
    <div class="w-full h-full mt-4 overflow-auto">
      <div class="w-2/3 mx-auto">
        <div class="bg-white shadow-md rounded my-6">
          <table class="text-left w-full border-collapse">
            <thead>
              <tr>
                <th
                  class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                >Encuestas</th>
                <th
                  class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                >
                  <div class="flex items-center">
                    <span class="flex-1">Fecha de creación</span>
                    <button class="border-2 rounded border-gray-700" @click="changeFormOrder">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 fill-current"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                        />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </svg>
                    </button>
                  </div>
                </th>
                <th
                  class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                >Número de respuestas</th>
                <th
                  class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                >Acciones</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="form in filteredForms">
                <tr class="hover:bg-gray-200 border-b border-gray-300" :key="form.id">
                  <td class="flex flex-col py-4 px-6">
                    <div class="text-gray-900">{{form.nombre}}</div>
                    <div class="text-gray-700 text-xs">{{form.category_name}}</div>
                  </td>
                  <td class="py-4 px-6">{{form.created_date | moment('DD/MM/YYYY hh:mm a')}}</td>
                  <td class="py-4 px-6">{{form.number_answers}} respuestas</td>
                  <td class="py-4 px-6">
                    <div class="flex flex-wrap items-center justify-center">
                      <router-link
                        v-if="form.number_answers === '0'"
                        :to="{name: 'editarCuestionario', params: {id: form.id}}"
                        class="text-white font-bold mb-1 py-1 px-3 rounded text-xs bg-cdmx-green hover:bg-cdmx-green-dark"
                      >Editar</router-link>
                      <a
                        class="text-white cursor-pointer font-bold mb-1 py-1 px-3 ml-2 rounded text-xs bg-red-500 hover:bg-cdmx-red"
                        @click="showConfirmDialog(form.id, form.nombre)"
                      >Eliminar</a>
                      <a
                        class="text-white cursor-pointer font-bold mb-1 py-1 px-3 ml-2 rounded text-xs bg-cdmx-blue-light hover:bg-cdmx-blue-dark"
                        @click="openFormModal(form.id, form.nombre)"
                      >Enviar encuesta</a>
                      <router-link
                        v-if="form.number_answers !== '0'"
                        :to="{name: 'respuestasCuestionario', params: {id: form.id}}"
                        class="text-white font-bold mb-1 py-1 px-3 ml-2 rounded text-xs bg-cdmx-purple-light hover:bg-cdmx-purple-dark"
                      >Ver respuestas</router-link>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea eliminar la encuesta?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deleteForm()"
        >Eliminar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <form-modal :nameForm="currentFormName" :showing="showFormModal" :formId="formId" @close="closeModal"></form-modal>
    <alert-dialog :showing="showingDialog">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Encuesta enviada</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-green"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingDialog = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import AlertDialog from "./AlertDialog";
import FormModal from "./FormModal";

export default {
  name: "form-list",
  data() {
    return {
      forms: [],
      showingConfirm: false,
      showingError: false,
      currentFormId: -1,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      showFormModal: false,
      formId: null,
      showingDialog: false,
      formCategories: [],
      categoryFilter: "-1",
      formOrder: "downward",
      currentFormName: ""
    };
  },
  components: {
    AlertDialog,
    FormModal
  },
  created(){
    let that = this;
/*     this.$socket.$subscribe("updateCategoryPollToMonitor", () => {
      that.fetchForms();
      that.fetchFormCategories();
    }); */
  },
  mounted() {
    this.fetchForms();
    this.fetchFormCategories();
  },
  methods: {
    fetchForms() {
      this.axios
        .get(backend_url + "/api/polls", this.config)
        .then(response => {
          this.forms = response.data;
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    showConfirmDialog(formId, formName) {
      this.showingConfirm = true;
      this.currentFormId = formId;
      this.currentFormName = formName;
    },
    openFormModal(formId, formName) {
      this.formId = formId;
      this.currentFormName = formName;
      this.showFormModal = true;
    },
    closeModal(type) {
      if (type === "dismiss") {
        this.showFormModal = false;
      } else {
        this.showFormModal = false;
        this.showingDialog = true;
      }
    },
    sendPoll(formId) {
      this.axios
        .post(backend_url + "/api/polls/send/" + formId)
        .then(response => {
          //this.forms = response.data;
          console.log(response);
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    deleteForm() {
      this.axios
        .delete(backend_url + "/api/polls/" + this.currentFormId, this.config)
        .then(response => {
          return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
              "module": "Encuestas", 
              "action": "Eliminación de una encuesta", 
              "observation": this.currentFormName,
              "email": localStorage.getItem("email")
            },
            this.config
          )
        })
        .then(response => {
          this.fetchForms();
          this.currentFormId = -1;
          this.showingConfirm = false;
        })
        .catch(error => {
          this.showingError = false;
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchFormCategories() {
      this.axios
        .get(backend_url + "/api/polls/categories/listAll", this.config)
        .then(response => {
          this.formCategories = response.data;
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    }
  },
  computed: {
    filteredForms() {
      return this.forms
        .filter(form => {
          return (
            this.categoryFilter === "-1" ||
            form.id_categoria === this.categoryFilter
          );
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            return new Date(a.created_date) - new Date(b.created_date);
          } else {
            return new Date(b.created_date) - new Date(a.created_date);
          }
        });
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>